export var UnknownLocationId = '00000000-0000-0000-0000-000000000000';
//# sourceMappingURL=location.js.map